import React from 'react';
import { Checkbox, Radio } from '@mui/material';
export const ListSelectionInput = _ref => {
  let {
    selectionType = 'multiple',
    selected,
    ariaLabel,
    onSelection,
    isPartiallySelected
  } = _ref;
  switch (selectionType) {
    default:
    case 'multiple':
      return /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary",
        checked: selected,
        name: ariaLabel,
        inputProps: {
          'aria-label': ariaLabel
        },
        onClick: onSelection,
        indeterminate: isPartiallySelected
      });
    case 'single':
      return /*#__PURE__*/React.createElement(Radio, {
        color: "primary",
        checked: selected,
        name: ariaLabel,
        inputProps: {
          'aria-label': ariaLabel
        },
        onChange: onSelection
      });
  }
};
export default ListSelectionInput;